import { FunctionComponent, useContext, useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useAuth } from "../auth";
import { announcementService } from "../service/AnnouncementService";

interface LocationAutocompleteProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
}

// Lets admins pick from addresses used on past events (fetched from GET /api/announcement/locations,
// which already returns a distinct list) instead of retyping them, while still allowing a brand new
// address to be typed in (freeSolo).
const LocationAutocomplete: FunctionComponent<LocationAutocompleteProps> = ({ value, onChange, label = "Location", disabled }) => {
  const { cookies } = useContext(useAuth);
  const [options, setOptions] = useState<string[]>([]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const token = cookies?.UserAuth?.token || '';
        const fetched = await announcementService.getUniqueLocations(token);
        // Belt-and-suspenders de-dupe on top of the server's DISTINCT query.
        setOptions(Array.from(new Set(fetched)).sort());
      } catch (err) {
        console.error('Failed to load locations', err);
      }
    };
    fetchLocations();
  }, [cookies]);

  return (
    <Autocomplete
      freeSolo
      disabled={disabled}
      options={options}
      value={value}
      onChange={(_, newValue) => onChange(newValue || '')}
      onInputChange={(_, newInputValue) => onChange(newInputValue)}
      renderInput={(params) => (
        <TextField {...params} label={label} fullWidth />
      )}
    />
  );
};

export default LocationAutocomplete;
